import React from "react";
import TriathlonLocation from "./Components/MapLocate";
import { loadEpreuve } from "./requests";
import { coord } from "./Components/MapLocate";
import { QueryTriathlon } from "./Components/QueryTriathlon";
import moment from "moment";
// import images and icons
import ImageTriathlonDetail from "./medias/calendrier_triathlon.png";
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
import PoolIcon from "@material-ui/icons/Pool";
import LanguageIcon from "@material-ui/icons/Language";
import Relay from "@material-ui/icons/People";
import Facebook from "@material-ui/icons/Facebook";

// function to check if var are empty
function ifExists(item, titreRubrique, unity) {
  return item && titreRubrique !== "" ? (
    <span>
      {titreRubrique} : {item} {unity}
    </span>
  ) : null;
}

export class EpreuveDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { epreuve: null, epreuves: [] };
  }

  async componentDidMount() {
    const { epreuveId } = this.props.match.params;
    const epreuve = await loadEpreuve(epreuveId);
    this.setState({ epreuve });
  }
  // triathlon size
  regularDistance(param) {
    switch (param) {
      case "XS":
        return "XS : 400 m natation,	10 km vélo,	2,5 km course à pied. ";
      case "S":
        return "S : 750 m natation,	20 km vélo,	5 km course à pied. ";
      case "M":
        return "M : 1500 m natation,	40 km vélo,	10 km course à pied. ";
      case "L":
        return "L : 1900 m natation,	90 km vélo,	21 km course à pied. ";
      case "XL":
        return "XL : 4000 m natation,	120 km vélo,	30 km course à pied. ";
      case "XXL":
        return "XXL : 3800 m natation,	180 km vélo,	42,195 km course à pied. ";
    }
  }
  // cross triathlon size
  regularCrossDistance(param) {
    switch (param) {
      case "XS":
        return " XS : 250 m natation,	5,5 km VTT,	2,2 km trail. ";
      case "S":
        return " S : 500 m natation,	11 km VTT,	4 km trail. ";
      case "M":
        return " M : 1000 m natation,	22 km VTT,	10 km trail. ";
      case "L":
        return " L : 2000 m natation,	44 km VTT,	16 km trail. ";
      case "XL":
        return " XL : 3000 natation,	66 km VTT,	24 km trail. ";
    }
  }

  render() {
    const { epreuve } = this.state;

    // const epreuvesResult = loadEpreuves(epreuve.region, "", 0, 2022,
    //   ["xs", "s", "M", "L", "XL", "XXL"]);
    // console.log("epreuvesResult", epreuvesResult);

    function createMarkup() {
      return { __html: epreuve.region };
    }

    if (!epreuve) {
      return "";
    }

    return (
      <section>
        <div className="row px-0">
          <img
            src={ImageTriathlonDetail}
            alt="Description du triathlon sélectionné"
            className="w-100 img-fluid"
          />
        </div>

        {/* Title */}
        <div className="row mt-2">
          <div className="col-lg-2"></div>
          <div className="col-lg-2">
            <span className="d-block p-2 bg-dark text-white text-center">
              {" "}
              {epreuve.date.slice(0, 10)}
            </span>
            <span className="d-block p-2 bg-primary text-white text-center font-weight-bold">
              {epreuve.city}
            </span>
          </div>
          <div className="col-lg-6 pl-0">
            <PoolIcon className="mr-1 " />
            <DirectionsBikeIcon className="mr-1" />
            <DirectionsRunIcon />

            <h1 className="title">{epreuve.name_event}</h1>
            <h2 className="subtitle"></h2>
            <div>
              <p
                className="text-muted"
                dangerouslySetInnerHTML={createMarkup()}
              />
            </div>
            <div>
              <p className="font-weight-bold">
                {epreuve.races.length > 1
                  ? epreuve.races.length + " formats de course sont proposés"
                  : "Format de la course"}{" "}
                : {epreuve.races.map((item) => " " + item.type_triathlon + ",")}
              </p>

              <div dangerouslySetInnerHTML={{ __html: epreuve.description }} />
            </div>
          </div>
          <div className="col-lg-2 text-center mt-2">
            <h5>
              Département&nbsp;
              <span className="bg-primary rounded px-2 text-white">
                {epreuve.department.length === 1
                  ? 0 + epreuve.department
                  : epreuve.department}
              </span>
            </h5>
          </div>
        </div>
        <div>
          <div className="mt-0 mb-4"></div>
          <div className="container ">
            <div className="row ">
              {/* First column */}
              <div className="col-lg-4 mb-4">
                {/* Display map */}
                <div className="row">
                  {epreuve.map_coord !== null ? (
                    <div className="d-block mb-2 mx-0 ">
                      <TriathlonLocation
                        coord={coord(epreuve.map_coord)}
                        popup={[
                          epreuve.id,
                          epreuve.name_event,
                          epreuve.races[0].type_triathlon,
                        ]}
                        region={epreuve.region}
                      />
                      <p>{"Coordonnées :" + epreuve.map_coord.split(":")[0]}</p>
                    </div>
                  ) : null}
                </div>
                {/* Display organisation */}
                <div className="mt-3">
                  <b>Organisateur</b>
                  <br />
                  {epreuve.organisation[0] !== null ? (
                    <div>
                      <h4 className="text-primary">
                        {epreuve.organisation[0].name_org}
                      </h4>

                      <div className="text-muted mb-2">
                        {ifExists(epreuve.organisation[0].contact, "Contact")}{" "}
                        {epreuve.organisation[0].contact ? <br /> : null}
                        {ifExists(epreuve.organisation[0].address, "Adresse")}
                        {epreuve.organisation[0]
                          ? epreuve.organisation[0].zipcode +
                            " - " +
                            epreuve.organisation[0].city
                          : null}
                      </div>
                      <p>
                        <LanguageIcon className="mr-2" />
                        <a
                          href={epreuve.organisation[0].website}
                          target="_blank"
                          className="text-primary"
                          rel="noreferrer"
                        >
                          {epreuve.organisation[0].website}
                        </a>
                      </p>
                      <p>
                        <MailOutlineIcon className="mr-2" />
                        <a
                          href={`mailto:${epreuve.organisation[0].email}`}
                          target="_blank"
                          className="text-primary"
                          rel="noreferrer"
                        >
                          {epreuve.organisation[0].email}
                        </a>
                      </p>
                      <p>
                        <PhoneInTalkIcon className="mr-2" />
                        {epreuve.organisation[0].phonenumber}
                      </p>
                      <p>
                        <a
                          href={epreuve.organisation[0].facebook}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Facebook className="mr-2" />
                        </a>
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>

              {/* Second column event details */}
              <div className="col-lg-8 px-0 order-first order-md-last">
                <div className="container">
                  <div className="row mb-5">
                    {epreuve.races.map((item, key) => (
                      <div
                        className="btn border border-warning col-lg-5 mr-3 mb-3 text-left"
                        key={key}
                      >
                        <p>
                          <span className="font-weight-bold text-center">
                            Distance {item.type_triathlon}{" "}
                            {item.date && item.date !== epreuve.date
                              ? " (" +
                                moment(item.date.slice(0, 10)).format(
                                  "DD/MM/YYYY"
                                ) +
                                ")"
                              : null}
                          </span>
                        </p>
                        <hr className="border-warning"></hr>
                        <p>
                          {item.crosstri === "0" ? (
                            item.details ? (
                              item.details
                            ) : (
                              this.regularDistance(item.type_triathlon)
                            )
                          ) : item.details ? (
                            <span>
                              <span className="bg-warning font-weight-bold px-2 text-white">
                                Cross
                              </span>{" "}
                              {item.details}
                            </span>
                          ) : (
                            <span>
                              <span className="bg-warning font-weight-bold px-2 text-white">
                                Cross
                              </span>{" "}
                              {this.regularCrossDistance(item.type_triathlon)}
                            </span>
                          )}
                        </p>
                        {item.Swimenv ? (
                          <p>
                            <PoolIcon className="mr-1 " /> en {item.Swimenv}
                          </p>
                        ) : null}
                        {item.Elevation_bike ? (
                          <span>
                            <DirectionsBikeIcon className="mr-1 " /> D+{" "}
                            {item.Elevation_bike} m
                          </span>
                        ) : null}
                        {item.Elevation_run ? (
                          <span>
                            {" "}
                            <DirectionsRunIcon className="mr-1 " /> D+{" "}
                            {item.Elevation_run} m
                          </span>
                        ) : null}

                        <p>
                          {ifExists(
                            item.price_triathlon,
                            "Montant de l'inscription",
                            " euros."
                          )}
                        </p>
                        <p>{ifExists(item.bibs, "Nombre de places")}</p>

                        <p>
                          {item.relay === "1" ? (
                            <span className="text-warning">
                              <Relay className="mr-1 " />
                              Ouvert en relais
                            </span>
                          ) : null}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* List of triathlons in the same region */}
            <div className="row">
              <div className="col-lg-4 "></div>
              <div className="col-lg-8 ">
                <span className="border-top border-bottom border-warning">
                  DANS LA MÊME RÉGION
                </span>
                <QueryTriathlon
                  regionFilter={epreuve ? epreuve.region : "Toute la France"}
                  yearFilter={Number(epreuve.date.slice(-13, -9))}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
